// extracted by mini-css-extract-plugin
export default {"wrapper":"CardGrade_wrapper__PeRbX","infoWrapper":"CardGrade_infoWrapper__5l8Iz","divider":"CardGrade_divider__onQoo","maxGrade":"CardGrade_maxGrade__k7nSw"};